export class CognitoAuthenticated {
  static readonly type = '[CognitoAuthenticated] change one';
  constructor(public isAuthenticated: boolean) {}
}

export class CognitoIdToken {
  static readonly type = '[CognitoIdToken] change one';
  constructor(public idToken: string) {}
}

export class CognitoAccessToken {
  static readonly type = '[CognitoAccessToken] change one';
  constructor(public accessToken: string) {}
}
